import React from 'react';
import { Link } from 'react-router-dom';
import timelineIcon from '../assets/ZeroRiskImplementation-icon.svg';

const ZeroRiskImplementation = () => {
    const steps = [
        {
            id: 1,
            weeks: "Week 1",
            title: "Discovery & Connectivity",
            description: "We map your current systems, workflows, and data, trading and clearing sources."
        },
        {
            id: 2,
            weeks: "Week 2-6",
            title: "Data Mapping & Workflows",
            description: "Configure your books, accounts, specific business rules and integrations with vendors."
        },
        {
            id: 3,
            weeks: "Week 7-10",
            title: "Parallel Run Validation",
            description: "Match P&L, payouts, and exceptions side-by-side with existing systems."
        },
        {
            id: 4,
            weeks: "Week 11-12",
            title: "Cutover & Stabilization",
            description: "Seamless transition with full support and monitoring."
        }
    ];

    return (
        <section className="w-full bg-[#F1F1F1] py-20 overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-4 md:px-8">
                {/* Header */}
                <div className="text-center mb-16 max-w-4xl mx-auto">
                    <h2 className="font-oswald text-black text-3xl md:text-5xl font-bold uppercase mb-6 tracking-tight">
                        IMPLEMENTATION: ZERO "BIG-BANG" RISK
                    </h2>
                    <p className="font-inter text-gray-600 text-lg md:text-xl">
                        Parallel run migration means you validate everything before cutover—no gambling with your desk
                    </p>
                </div>

                {/* Horizontal Timeline */}
                <div className="relative max-w-7xl mx-auto mb-16">
                    {/* Timeline Steps Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4">
                        {steps.map((step, index) => (
                            <div key={step.id} className="relative flex flex-col items-center md:items-start">
                                {/* Icon Circle */}
                                <div className="relative z-10 flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-white border-4 border-[#00C2FF] rounded-full shadow-lg mb-6">
                                    <img
                                        src={timelineIcon}
                                        alt=""
                                        loading="lazy"
                                        className="w-6 h-6 md:w-8 md:h-8 object-contain"
                                    />
                                </div>

                                {/* Connecting Line - Extends from circle to right, including after last circle */}
                                <div className="hidden md:block absolute top-10 left-10 w-full h-[3px] bg-[#00C2FF] z-0"></div>

                                {/* Week Badge */}
                                <div className="inline-block bg-[#E0F7FA] text-[#00C2FF] font-bold px-4 py-2 rounded-md text-sm mb-4">
                                    {step.weeks}
                                </div>

                                {/* Title and Description Container */}
                                <div className="w-full px-4 md:px-0">
                                    {/* Title */}
                                    <h3 className="font-inter text-lg md:text-xl font-bold mb-3 text-black text-center md:text-left">
                                        {step.title}
                                    </h3>

                                    {/* Description */}
                                    <p className="font-inter text-gray-600 text-sm text-center md:text-left md:pr-9 leading-relaxed">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA Button */}
                <div className="text-center">
                    <Link
                        to="/schedule-demo"
                        className="bg-[#00C2FF] hover:bg-[#00a0d6] text-white font-bold py-3 px-10 rounded-[16px] shadow-md transition-colors text-lg inline-block">
                        Request a demo
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ZeroRiskImplementation;
